import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { DEFAULT_UI_LANGUAGE } from '../i18n/language';

type AuthPathRedirectProps = {
  segment: 'reset' | 'register' | 'verify';
};

/** Redirect /reset → /fr/reset preserving query string (e.g. ?token=). */
const AuthPathRedirect: React.FC<AuthPathRedirectProps> = ({ segment }) => {
  const location = useLocation();
  return (
    <Navigate
      to={`/${DEFAULT_UI_LANGUAGE}/${segment}${location.search}`}
      replace
    />
  );
};

export default AuthPathRedirect;
